export default __webpack_public_path__ + "static/media/mastercard.9ea3e5de.png";